import React from 'react';
import LeftBar from '../../Components/LeftBar';
import Dashnav from '../../Components/Dashnav';
import DirectExpensesComp from './DirectExpensesComp';

function DirectExpenses() {
  return (
    <div className="mainContainer">
      <LeftBar />
      <div className="theMainContainer">
        <Dashnav />
        <DirectExpensesComp />
      </div>
    </div>
  );
}

export default DirectExpenses;
